// @core/api/endpoints/task/update_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
  UpdateTaskRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update task
 * Updates task fields specified in the field mask. Changes are tracked in the activity log and may trigger notifications to watchers.
 */
export async function UpdateTask(
  task_id: string,
  data: UpdateTaskRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.put<TaskResponse>(requestPath, data, requestOptions);
}
